import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import gallery1 from "../../../assets/2023_aca/img_1.JPG";
import gallery2 from "../../../assets/2023_aca/img_2.JPG";
import gallery3 from "../../../assets/2023_aca/img_3.JPG";
import gallery4 from "../../../assets/2023_aca/img_4.JPG";
import gallery5 from "../../../assets/2023_aca/img_5.JPG";
import gallery6 from "../../../assets/2023_aca/img_6.JPG";
import gallery7 from "../../../assets/2023_aca/img_7.JPG";
import gallery8 from "../../../assets/2023_aca/img_8.JPG";
import gallery9 from "../../../assets/2023_aca/img_9.JPG";
import gallery10 from "../../../assets/2023_aca/img_10.JPG";
import gallery11 from "../../../assets/2023_aca/img_11.JPG";
import gallery12 from "../../../assets/2023_aca/img_12.JPG";
import gallery13 from "../../../assets/2023_aca/img_13.JPG";
import gallery14 from "../../../assets/2023_aca/img_14.JPG";
import gallery15 from "../../../assets/2023_aca/img_15.JPG";
import gallery16 from "../../../assets/2023_aca/img_16.JPG";

const Gallery = () => {
  const theme = useTheme();

  const ColorButton = styled(Button)(() => ({
    color: "#fff",
    width: 225,
    height: 65,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "capitalize",
    backgroundColor: "#D7A036",
    borderColor: "#D7A036",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#004165",
      borderColor: "#004165",
    },
  }));

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const photos = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
    gallery13,
    gallery14,
    gallery15,
    gallery16,
  ];

  const photosToShow = isMd ? photos : photos.slice(0, photos.length);

  return (
    <Box padding={{ xs: "20% 0%", sm: "4% 0%" }}>
      <Box>
        <Box width={{ xs: "100%", sm: "40%" }}>
          <Typography
            variant="h3"
            color="#fff"
            fontWeight={800}
            paddingBottom={"2%"}
            textAlign={"center"}
          >
            <Typography
              component={"span"}
              color="#D7A036"
              fontWeight={800}
              variant={"h3"}
            >
              The Photo {""}
            </Typography>
            Gallery
          </Typography>
        </Box>
        <Typography
          variant={"body2"}
          fontWeight={500}
          color={"#fff"}
          padding={"1% 0%"}
          textAlign={"center"}
        >
          Images from 2023 Active Citizens Awards
        </Typography>
      </Box>
      <Box marginTop={{ xs: "5%", sm: "2%" }}>
        {photosToShow.map((item, index) => (
          <Box
            component="img"
            height={{ xs: "27vh", sm: "220px" }}
            onClick={() => {
              setCurrentImageIndex(index);
              setIsViewerOpen(!isViewerOpen);
            }}
            sx={{
              cursor: "pointer",
              objectFit: "cover",
            }}
            src={item}
            alt={"aca2023_img"}
            marginRight={{ xs: "0%", sm: "0.5%" }}
            marginBottom={{ xs: "1%", sm: "0.5%" }}
            width={{ xs: "100%", sm: "24.5%" }}
          />
        ))}

        <FsLightbox
          toggler={isViewerOpen}
          sources={photos}
          slide={currentImageIndex + 1}
        />
      </Box>
      <Box
        display={{ xs: "none", sm: "flex" }}
        justifyContent={"center"}
        paddingTop={"2%"}
      >
        <ColorButton
          component={"a"}
          variant="outlined"
          size="medium"
          href={"/event-gallery/2023-awards"}
        >
          Open Gallery
        </ColorButton>
      </Box>
    </Box>
  );
};

export default Gallery;
